import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.1.2_@biomejs+biome@2.2.2_@capacitor+preferences@7.0.2_@capacitor+core@8.1.0__@pa_ea10031bc0f0ac6559d30f3b7d869e23/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}